import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHome } from '@fortawesome/free-solid-svg-icons';
// import { faHomeLgAlt } from '@fortawesome/pro-solid-svg-icons';
import characterSections from 'state/static-data/character-sections';
import {
  selectCharacterSection,
  changeLanguage,
} from 'state/action-creators/characters';
import { Language } from 'types/enums';
import { setLocale, translate } from 'translations/translator';
const t = (key) => translate('lnf', key);
const tCommon = (key) => translate('common', key);

const LetterFormationHeader = () => {
  const classes = useStyles();
  const {
    container,
    menuBar,
    menuButton,
    menuIcon,
    dividerGray,
    title,
    subsectionMenu,
    subsectionMenuWrapper,
    subsection,
    selectedSubsection,
    languageFormControl,
    languageSelect,
  } = classes;
  const { languageId, selectedCharacterSection } = useSelector(
    (state: any) => state.characters
  );
  const history = useHistory();
  const dispatch = useDispatch();

  const goHome = () => {
    history.push('/');
  };

  const onClickCharacterSection = (sectionName) => {
    history.push('/');
    dispatch(selectCharacterSection(sectionName));
  };

  const selectLanguage = (event) => {
    const language = event.target.value;

    setLocale(language);
    dispatch(changeLanguage(language));
  };

  return (
    <Box className={container}>
      <Box className={menuBar}>
        <Box className={menuButton}>
          <FontAwesomeIcon icon={faBars} className={menuIcon} />
        </Box>
        <Box className={menuButton} onClick={goHome}>
          <FontAwesomeIcon icon={faHome} className={menuIcon} />
        </Box>
        <Box className={title}>{t('title')}</Box>
      </Box>
      <Box className={subsectionMenuWrapper}>
        <Box className={subsectionMenu}>
          {Object.keys(characterSections).map((sectionName) => {
            return (
              <Box
                key={sectionName}
                className={
                  sectionName === selectedCharacterSection
                    ? selectedSubsection
                    : subsection
                }
                onClick={() => onClickCharacterSection(sectionName)}
              >
                {t(sectionName)}
                <Box className={dividerGray} />
              </Box>
            );
          })}
          <FormControl variant='outlined' className={languageFormControl}>
            <InputLabel id='languageDropdownLabel'>
              {tCommon('language')}
            </InputLabel>
            <Select
              labelId='languageDropdownLabel'
              value={languageId}
              onChange={selectLanguage}
              label={tCommon('language')}
              className={languageSelect}
            >
              {Object.values(Language).map((language: any) => {
                return (
                  <MenuItem key={language} value={language}>
                    {tCommon(language)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {},
  menuBar: {
    display: 'flex',
    backgroundColor: '#2671ba',
    color: 'white',
    fontSize: '20px',
    fontFamily: 'Futura-Semibold',
    height: '60px',
    borderBottom: '.5px solid #295682',
  },
  menuButton: {
    cursor: 'pointer',
    borderRight: '1px solid black',
  },
  menuIcon: {
    margin: '10px',
    marginTop: '22px',
  },
  dividerGray: {
    borderRight: '1px solid #999999',
    width: '0px',
    height: '100%',
    right: '0px',
    float: 'right',
  },
  title: {
    margin: '10px',
    paddingTop: '5px',
    fontSize: '25px',
  },
  subsectionMenuWrapper: {
    width: '100%',
    height: '50px',
    borderTop: '1px solid #999999',
    borderBottom: '1px solid #999999',
  },
  subsectionMenu: {
    display: 'flex',
    fontSize: '20px',
    height: '100%',
    fontFamily: 'Futura-Semibold',
    textAlign: 'center',
    marginLeft: '38px',
    marginRight: '38px',
    lineHeight: '50px',
  },
  subsection: {
    flex: '1 1 0px',
  },
  selectedSubsection: {
    borderBottom: '2px solid #2671ba',
    backgroundColor: '#e5e5e5',
    flex: '1 1 0px',
  },
  languageFormControl: {
    width: '150px',
    marginLeft: '20px',
    marginTop: '10px',
  },
  languageSelect: {
    height: '35px',
  },
});

export default LetterFormationHeader;
